import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("sk_cart")) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("sk_cart", JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const i = prev.findIndex((p) => p.id === product.id);
      if (i >= 0) {
        const next = [...prev];
        next[i] = { ...next[i], quantity: next[i].quantity + qty };
        return next;
      }
      return [...prev, { id: product.id, name: product.name, price: product.price, image: product.image, category: product.category, shipping_fee: product.shipping_fee || 0, quantity: qty }];
    });
    setOpen(true);
  };

  const remove = (id) => setItems((prev) => prev.filter((p) => p.id !== id));
  const setQty = (id, qty) =>
    setItems((prev) => (qty <= 0 ? prev.filter((p) => p.id !== id) : prev.map((p) => (p.id === id ? { ...p, quantity: qty } : p))));
  const clear = () => setItems([]);

  const total = items.reduce((s, p) => s + p.price * p.quantity, 0);
  const count = items.reduce((s, p) => s + p.quantity, 0);

  const value = useMemo(
    () => ({ items, add, remove, setQty, clear, total, count, open, setOpen }),
    [items, open, total, count]
  );

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};
